<template>
    <div class="flex ml-0 flex-column w-full md:w-1/3 lg:w-1/3 pb-2">

        <vs-input class="border-grey-light w-full" type="string" v-model="project_id"
                  label="Project ID" required />

        <h3 class="mt-8 mb-4">App Distribution</h3>

        <vs-input class="border-grey-light w-full mb-4" type="string" v-model="app_distribution_android_id"
                  label="Android ID" required />

        <vs-input class="border-grey-light w-full mb-4" type="string" v-model="app_distribution_ios_id"
                  label="iOS ID" required />

        <vs-input v-if="hasWatch" class="border-grey-light w-full mb-4" type="string" v-model="app_distribution_apple_watch_id"
                  label="Apple Watch ID" required />

    </div>
</template>

<script>
import loader from "@/modules/Shared/Mixins/loader";
import ApplicationService from "@/modules/Admin/Services/ApplicationService";

export default {
  name: "FirebaseSettings",
  mixins: [loader],
  props: {
      firebase: {
          type: Object,
      }
  },
  data() {
    return {
        project_id: null,
        app_distribution_android_id: null,
        app_distribution_ios_id: null,
        app_distribution_apple_watch_id: null,
        hasWatch: false,
    }
  },
  async created() {
    if (this.firebase) {
        this.project_id = this.firebase.project_id
        this.app_distribution_android_id = this.firebase.app_distribution_android_id
        this.app_distribution_ios_id = this.firebase.app_distribution_ios_id
        this.app_distribution_apple_watch_id = this.firebase.app_distribution_apple_watch_id
    }
  },
  methods: {
    async onActive() {
        await this.loadAndNotifyError(async () => {
            const modules = await ApplicationService.getApplicationModules(this.$route.params.uuid)
            this.hasWatch = !!modules.find(module => module.type.name === 'watch')
        })
    },
    save() {
        return new Promise(async (resolve, reject) => {
            if (!this.project_id && !this.app_distribution_android_id && !this.app_distribution_ios_id && !this.app_distribution_apple_watch_id) {
                resolve()
            }

            this.loadAndNotifyError(async () => {
                const payload = {
                    project_id: this.project_id || null,
                    app_distribution_android_id: this.app_distribution_android_id || null,
                    app_distribution_ios_id: this.app_distribution_ios_id || null,
                    app_distribution_apple_watch_id: this.app_distribution_apple_watch_id || null
                }
                await ApplicationService.editApplicationFirebase(this.$route.params.uuid, payload)

            }).then((result) => {
                if (!result) {
                    reject()
                    return;
                }
                resolve()
            })
        })
    }
  }
};
</script>
